import type { RefObject } from 'react';
import { useEffect, useState } from 'react';

export function useGetLineHeight(elementRef: RefObject<HTMLElement>) {
  const [lineHeight, setLineHeight] = useState('');

  useEffect(() => {
    const element = elementRef.current;
    if (element) {
      const lineHeightValue = window.getComputedStyle(element).lineHeight;
      setLineHeight(lineHeightValue);
    }
  }, [elementRef]);

  return lineHeight;
}
